import { toast } from "sonner";
import type { Endpoint, HttpMethod, ParamValues } from "../developer-api";

export const METHOD_STYLES: Record<HttpMethod, string> = {
  GET: "bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/30",
  POST: "bg-green-500/15 text-green-700 dark:text-green-300 border-green-500/30",
  PUT: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30",
  DELETE: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/30",
};

export function statusStyle(status: number): string {
  if (status >= 200 && status < 300)
    return "bg-green-500/15 text-green-700 dark:text-green-300 border-green-500/30";
  if (status >= 400 && status < 500)
    return "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30";
  if (status >= 500)
    return "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/30";
  return "bg-muted text-muted-foreground border-border";
}

export async function copyToClipboard(value: string, label: string) {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} copied`);
  } catch {
    toast.error(`Could not copy ${label}`);
  }
}

export function initialValuesFor(endpoint: Endpoint, clientId?: string): ParamValues {
  const v: ParamValues = {};
  for (const p of endpoint.params) {
    if (p.defaultFromClientId && clientId) v[p.name] = clientId;
    else v[p.name] = "";
  }
  return v;
}

export function missingRequired(endpoint: Endpoint, values: ParamValues): string[] {
  return endpoint.params
    .filter((p) => p.required && (!values[p.name] || values[p.name].trim() === ""))
    .map((p) => p.name);
}

export type RequestResult = {
  status: number;
  statusText: string;
  latencyMs: number;
  count: number | null;
  body: string;
  ok: boolean;
};
